import service from '@/services/SIRejecutareportes';

export default {
  namespaced: true,

  actions: {
    /**
     * Permite obtener los parámetros de un WebApp Vue.
     */
    read({ dispatch, rootGetters }, { configReport, configGroup }) {
      return new Promise((resolve, reject) => {
        const payload = {
          dsSIRRep_rpt: {
            eeDatos: [rootGetters['auth/state']],
            eeSIRrep_rpt: [configReport],
          },
        };

        if (configGroup.length) {
          payload.dsSIRRep_rpt.eerep_gby = configGroup;
        }

        let notification;

        service
          .post(payload)
          .then((response) => {
            const data = response.data?.response;
            if (data?.dsSIRRep_rpt.dsSIRrep_rpt.eeEstados?.[0]?.Returnid === 0) {
              resolve(data.polcdata.Reporte);
            } else if (data?.dsSIRRep_rpt.dsSIRrep_rpt.eeEstados?.[0]?.Returnid === 98) {
              resolve([]);
            } else {
              notification = {
                code: data?.dsSIRRep_rpt.dsSIRrep_rpt.eeEstados?.[0]?.Returnid || null,
                message: data?.dsSIRRep_rpt.dsSIRrep_rpt.eeEstados?.[0]?.Estado || null,
                timestamp: Date.now(),
                type: 'error',
              };

              throw notification;
            }
          })
          .catch((error) => {
            if (error?.type === undefined) {
              notification = {
                code: error?.name || null,
                message: error?.message || null,
                timestamp: Date.now(),
                type: 'error',
              };
            }

            dispatch('notification/create', notification, {
              root: true,
            });

            reject(notification);
          });
      });
    },
  },
};
